import activity from './zh-CN/activity';
import bonus from './zh-CN/bonus';
import common from './zh-CN/common';
import component from './zh-CN/component';
import finance from './zh-CN/finance';
import globalHeader from './zh-CN/globalHeader';
import invitation from './zh-CN/invitation';
import member from './zh-CN/member';
import menu from './zh-CN/menu';
import options from './zh-CN/options';
import pages from './zh-CN/pages';
import platform from './zh-CN/platform';
import pwa from './zh-CN/pwa';
import report from './zh-CN/report';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import tournament from './zh-CN/tournament';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...common,
  ...member,
  ...options,
  ...finance,
  ...tournament,
  ...bonus,
  ...invitation,
  ...platform,
  ...activity,
  ...report,
};
